export const MAX_TRADE_ASSETS = 20;
